<div class="kiln-visual-wrap">
  <div class="clock state-{{ clockState }}" [attr.title]="getClockTooltip()">
    <span class="clock-hand hour"></span>
    <span class="clock-hand minute"></span>
  </div>

  <div class="kiln">
    <div class="kiln-perspective">
      <!-- Zone tiers share one column; z-index only for overlap paint order (zone 1 on top) -->
      <div class="zone-prism zone-prism--1 state-{{ getZoneState(0) }}" [attr.title]="getZoneTooltip(0)">
        <div class="zone-prism-inner">
          <div class="zone-row">
            <div class="zone-face face-left"></div>
            <div class="zone-face face-center"></div>
            <div class="zone-face face-right"></div>
          </div>
        </div>
      </div>

      <div class="zone-prism zone-prism--2 state-{{ getZoneState(1) }}" [attr.title]="getZoneTooltip(1)">
        <div class="zone-prism-inner">
          <div class="zone-row">
            <div class="zone-face face-left"></div>
            <div class="zone-face face-center"></div>
            <div class="zone-face face-right"></div>
          </div>
        </div>
      </div>

      <div class="zone-prism zone-prism--3 state-{{ getZoneState(2) }}" [attr.title]="getZoneTooltip(2)">
        <div class="zone-prism-inner zone-prism-inner--tc">
          <div class="zone-row">
            <div class="zone-face face-left"></div>
            <div class="zone-face face-center"></div>
            <div class="zone-face face-right"></div>
          </div>
          <div class="thermocouple" [attr.title]="getThermocoupleTooltip()">
            <span class="thermocouple-probe-pin"></span>
            <span class="thermocouple-probe-body"></span>
            <span class="thermocouple-wire thermocouple-wire-a"></span>
            <span class="thermocouple-wire thermocouple-wire-b"></span>
          </div>
        </div>
      </div>

      <div class="kiln-base-legs">
        <div class="kiln-base">
          <span class="base-face face-left"></span>
          <span class="base-face face-center"></span>
          <span class="base-face face-right"></span>
        </div>
        <div class="legs">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>

  <div class="controller state-{{ controllerState }}" [attr.title]="getControllerTooltip()">
    <div class="controller-screen state-{{ controllerState }}"></div>
    <div class="controller-buttons">
      <span class="state-{{ getZoneState(0) }}"></span>
      <span class="state-{{ getZoneState(1) }}"></span>
      <span class="state-{{ getZoneState(2) }}"></span>
    </div>
  </div>

  <div class="outlet state-{{ outletState }}" [attr.title]="getOutletTooltip()">
    <ion-icon name="power-outline" aria-hidden="true"></ion-icon>
  </div>
</div>
